export const APP_NAME = 'Suwali';
export const SUPPORT_EMAIL = 'support@suwali.io';
export const SALES_EMAIL = 'support@suwali.io';
export const SCHEDULE_DEMO_LINK = 'https://www.suwali.io/demo';
export const DEFAULT_QUERY_STALE_TIME = 60000;
export const PAGINATION_WINDOW_SIZE = 20;
